import ChatMessageActionsDesktop from "../../components/chat-message-actions-desktop";

const ChatMessageActionsDesktopOutlet = <template>
  <div class="below-footer-outlet chat-message-actions-desktop-outlet">
    <ChatMessageActionsDesktop />
  </div>
</template>;

export default ChatMessageActionsDesktopOutlet;
